import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { fetchPosts } from "../lib/api";
import type { Post } from "../types/blog";
import { ChevronRight } from "lucide-react";

function BlogPreview() {
  const [posts, setPosts] = useState<Post[]>([]);

  useEffect(() => {
    fetchPosts().then(setPosts);
  }, []);

  // Get the latest 3 posts
  const latestPosts = posts.slice(0, 3);

  return (
    <section className="py-16 bg-white">
      <div className="container-custom">
        <div className="flex justify-between items-center mb-12">
          <h2 className="text-3xl font-bold">Latest from Our AI Blog</h2>
          <Link
            to="/blog"
            className="text-primary font-medium flex items-center hover:underline"
          >
            View all posts
            <ChevronRight className="h-5 w-5 ml-1" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {latestPosts.map((post, index) => (
            <div key={index} className="card">
              {!post.image ? (
                <img
                  src="https://hive-data-prod-cdn.thehive.ai/image_generation/1104299991/c9787b32-0421-11f0-b2d0-90fe74b182cd/image0_1024_1024.png?Expires=1757872378&Signature=hhtV0XBZWnm9tnpKpDO9WRtUlfzUbGsG3-qRcM-UsXvKWcqSaYQwVLoZHpP99SmRMF97~sUYS3X5OuuxlJ3KPrdqm428kytzIkIuQES1vy4HtZ5S4aQ4FpQjlogkKA~rrgCVry-Se7BSlIgShVLQF82IGQKHMvLuDOS1-PL~C3yvpvhu-6xXjDPJZl5OS~c2lv7jDiLkcJvCkODDOvkgtOOA77-aayfMtaD1dykZzm7K0-3RJcxAy3UHstoGJAFf7OeYmlY6hni4UZiIDTnuqby4832skqus7oz5EhwSOhnJvujDMqwo9qWpc5uE6tyj1dwsCVvdSSUwJ8bxh6czcg__&Key-Pair-Id=APKAIWMTNWCLWHZZ525A"
                  alt={post?.title}
                  className="h-48 w-full object-cover"
                />
              ) : (
                <img
                  src={post?.image}
                  alt={post?.title}
                  className="h-48 w-full object-cover"
                />
              )}
              <div className="p-6">
                {/* <span className="text-sm text-primary font-semibold">
                  Sustainability
                </span> */}
                <p className="text-sm text-gray-500 mb-2">
                  {new Date(post?.date).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </p>
                <h3 className="text-xl font-bold mb-2">
                  <Link
                    to={`/blog/${post?.slug}`}
                    className="text-gray-900 hover:text-primary-600 transition-colors"
                  >
                    {post?.title}
                  </Link>
                </h3>
                <p className="text-gray-600 mb-4">{post.excerpt}</p>
                <Link
                  to={`/blog/${post?.slug}`}
                  className="text-primary font-medium flex items-center hover:underline"
                >
                  Read more
                  <ChevronRight className="h-5 w-5 ml-1" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default BlogPreview;
